"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CustomToolTip_1 = __importDefault(require("../CustomToolTip"));
const tooltip_text_1 = require("@App/const/tooltip-text");
require("./index.scss");
const pagination_1 = require("@App/const/pagination");
const CompactViewToggle_1 = require("@Components/WorkItemV2/CompactViewToggle");
const PaginationResultsBlock = (props) => {
    const { workNumTitles, totalResults, justResults, hideNoResults, showCompactToggle } = props;
    const resultsMessage = props.resultsMessage ? props.resultsMessage : 'results';
    return (react_1.default.createElement("section", { className: 'table-head' },
        react_1.default.createElement("span", { className: 'results-with-tooltip' }, workNumTitles && totalResults > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", { className: 'small bold' },
                !justResults ? (react_1.default.createElement(react_1.default.Fragment, null,
                    "Showing ",
                    workNumTitles.firstTitle.toLocaleString(),
                    " -",
                    ' ',
                    workNumTitles.lastTitle.toLocaleString(),
                    " of\u00A0")) : (react_1.default.createElement(react_1.default.Fragment, null, "Showing\u00A0")),
                totalResults > pagination_1.PAGINATION.paginationLimit ? (react_1.default.createElement(react_1.default.Fragment, null,
                    pagination_1.PAGINATION.paginationLimit.toLocaleString(),
                    " accessible ",
                    resultsMessage,
                    " (Total",
                    ' ',
                    totalResults.toLocaleString(),
                    ")")) : (react_1.default.createElement(react_1.default.Fragment, null,
                    totalResults.toLocaleString(),
                    " ",
                    resultsMessage,
                    ' '))),
            totalResults > pagination_1.PAGINATION.paginationLimit && (react_1.default.createElement(CustomToolTip_1.default, { type: '?', info: tooltip_text_1.TOOLTIP_TEXT.pagination.totalResults })))) : (!hideNoResults && react_1.default.createElement("p", { className: 'small bold' }, "No results found"))),
        showCompactToggle && react_1.default.createElement(CompactViewToggle_1.CompactViewToggle, null)));
};
exports.default = PaginationResultsBlock;
